module.exports = __webpack_public_path__ + "static/media/Ad-Server-Dashboard-3.91f4fb4c.jpg";